// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + {39: "page","e": "async-index","ki": "why-giffgaff/page",}[chunkId] + "." + {39: "ce65b40479","e": "df68909578","ki": "8e0ad2a77f",}[chunkId] + ".css"
}